import List from './components/List'
import Form from './components/Form'

export default [
  {path: '/country', component: List, name: 'country.index'},
  {path: '/country/store', component: Form, name: 'country.store'},
  {path: '/country/:id', component: Form, name: 'country.update'}
]



// WEBPACK FOOTER //
// ./src/app/domains/country/routes.js